import { useMessage } from './useMessage'
import { UseQueryOptions } from 'react-query'
import { AIJobStatus } from 'types'
import { ChatMessage, isPendingVideoContent } from 'api/clients/ChatClient'

interface Props {
  threadId: number
  id: number
}

interface Options extends Omit<UseQueryOptions<{ message: ChatMessage }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollMessage = ({ threadId, id }: Props, options?: Options) => {
  return useMessage(
    { threadId, id },
    {
      refetchInterval: (data) => {
        const interval = options?.intervalMs ?? 500
        if (!data?.message) return interval

        const isTerminal =
          data.message.status !== undefined &&
          [AIJobStatus.Successful, AIJobStatus.Failed, AIJobStatus.Expired].includes(data.message.status)
        const hasPendingVideo = data.message.content?.some(isPendingVideoContent)

        if (isTerminal && !hasPendingVideo) return false
        return interval
      },
      ...options,
    },
  )
}
